module.exports = __webpack_public_path__ + "img/tz3.cc1acdfe.jpg";